<script setup>
import { ref, watch, inject, nextTick } from "vue"
import { router } from "@inertiajs/vue3"

const gsap = inject("gsap")
const ScrollTrigger = inject("ScrollTrigger")
router.on("navigate", e => {
	initParallax()
})
const initParallax = () => {
	nextTick(() => {
		ScrollTrigger.create({
			trigger: document.querySelector(".parallax-banner"),
			start: "top top",
			pin: true,
			pinSpacing: false
		})
	})
}
const props = defineProps({
	video: String,
	poster: String,
	title: String,
	subtitle: String
})
const isActiveVideo = ref(false)
const videoRef = ref(null)
watch(isActiveVideo, newValue => {})

function playVideo() {
	isActiveVideo.value = true
	videoRef.value.setAttribute("controls", "controls")
	videoRef.value.play()
}
</script>

<template>
	<section>
		<div class="parallax-banner relative h-screen w-full">
			<div v-if="!isActiveVideo" class="absolute inset-0 z-20 bg-gradient-to-t from-black/40 to-transparent"></div>
			<video ref="videoRef" :poster="'/storage/' + poster" :src="video" class="video h-full w-full object-cover"></video>
			<div v-if="!isActiveVideo" class="w-container absolute inset-0 z-30 flex items-end">
				<button v-if="video" class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" @click.prevent="playVideo">
					<svg class="w-20 md:w-28" viewBox="0 0 91 91" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M45.498 91C20.371 91 .001 70.629.001 45.501.001 20.373 20.371.004 45.498.004c25.129 0 45.499 20.369 45.499 45.497S70.627 91 45.498 91zm0-83.035C24.78 7.997 7.994 24.784 7.962 45.501c0 20.731 16.807 37.537 37.536 37.537 20.732 0 37.537-16.806 37.537-37.537 0-20.73-16.805-37.536-37.537-37.536zm14.503 38.788l-22.01 12.682a1.422 1.422 0 0 1-2.104-1.251V32.762a1.421 1.421 0 0 1 2.162-1.252l22.009 12.74a1.423 1.423 0 0 1-.057 2.503z"
							fill="#ffffff"
							fill-rule="evenodd"
						></path>
					</svg>
				</button>
				<div class="pb-32">
					<p v-if="subtitle" class="left-line light mb-2 font-semibold text-white" data-aos="fade-up" data-aos-delay="300" data-aos-duration="500">{{ subtitle }}</p>
					<p v-if="title" class="heading-2xl max-w-2xl font-heading text-white" data-aos="fade-up" data-aos-delay="300" data-aos-duration="500">{{ title }}</p>
				</div>
			</div>
		</div>
	</section>
</template>

<style scoped></style>
